export const REWARDS_CONCEPT_AMOUNT = 200000;
export const REDEEM_REWARDS_FEE_CATEGORY = 'discount';
export const REDEEM_REWARDS_FEE_SUBCATEGORY = 'cashback';
export const REWARDS_EARN_PERCENTAGE = 0.25;
export const CURRENCIES_FROM_WITH_REWARDS = ['INR', 'CNY'];
